import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { rxLookupFormValidations as validate } from './Validations';
import Button from '../../components/Button';
import styles from './RxLookupForm.css';
import UserIcon from '../../assets/User';
import RxIcon from '../../assets/Rx';
import IconInput from './IconInput';
import { numbersAndDashesOnly } from '../../util';

const RxLookupForm = ({ onSubmit, ...props }) => {
  const { valid, handleSubmit, error, submitting } = props;
  const globalErrorClass = error ? styles.rxSubmitFormGlobalError : '';
  return (
    <form
      onSubmit={handleSubmit}
      className={`${styles.rxSubmitForm} ${globalErrorClass}`}
    >
      <fieldset className={styles.rxSubmitFieldset}>
        <Field
          icon={<UserIcon />}
          type="text"
          name="lastName"
          placeholder="Last Name"
          component={IconInput}
        />
        <Field
          icon={<RxIcon />}
          type="text"
          name="rxNumber"
          placeholder="Rx Number"
          pattern="[0-9]*"
          component={IconInput}
          normalize={numbersAndDashesOnly}
        />
      </fieldset>
      {error ? (
        <div className={styles.errorContainer}>
          <span
            className={styles.errorMessage}
            dangerouslySetInnerHTML={{ __html: error }} // eslint-disable-line react/no-danger
          />
        </div>
      ) : (
        ''
      )}
      <Button
        disabled={!valid}
        onClick={handleSubmit}
        submitting={submitting}
        btnText="Find my RX"
      />
    </form>
  );
};
RxLookupForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

export default reduxForm({
  form: 'RxLookupForm',
  validate,
  initialValues: {
    rxNumber: EXAMPLE_RX,
    lastName: EXAMPLE_NAME,
  },
})(RxLookupForm);



// WEBPACK FOOTER //
// ./src/components/Forms/RxLookupForm.jsx